import {
  RESET_PASSWORD, RESET_PASSWORD_FAIL, RESET_PASSWORD_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  password: '',
  reset_success_message: '',
  reset_error_message: '',
};

const InviteConfirmation = (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_PASSWORD:
      return {
        ...state,
        error: action.payload,
      }

    case RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        reset_success_message: action.payload
      }

    case RESET_PASSWORD_FAIL:
      return {
        ...state,
        reset_error_message: action.payload,
      }

    default:
      return state
  }
}

export default InviteConfirmation;